module.exports = __webpack_public_path__ + "static/media/leaseStatActive.5daa3ac7.png";